import { render, staticRenderFns } from "./InternetAndMobileCard.vue?vue&type=template&id=29d56957&scoped=true"
import script from "./InternetAndMobileCard.vue?vue&type=script&lang=ts"
export * from "./InternetAndMobileCard.vue?vue&type=script&lang=ts"
import style0 from "./InternetAndMobileCard.vue?vue&type=style&index=0&id=29d56957&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d56957",
  null
  
)

export default component.exports